module.exports = __webpack_public_path__ + "media/images/controllers/root/kv-68df4d68dcf8d9fe66b65762be92c451.jpg";